
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSReturnTaxGrid extends Serenity.EntityGrid<POSReturnTaxRow, any> {
        protected getColumnsKey() { return 'Retail.POSReturnTax'; }
        protected getIdProperty() { return POSReturnTaxRow.idProperty; }
        protected getInsertPermission() { return POSReturnTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return POSReturnTaxRow.localTextPrefix; }
        protected getService() { return POSReturnTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}